import LanguageRegionCode from '@alltrails/shared/types/LanguageRegionCode';
import { MILLISECONDS_IN_DAY } from 'constants/DateConstants';
import useLanguageRegionCode from 'hooks/useLanguageRegionCode';
import { humanizeTimeSpan } from '@alltrails/shared/utils/timeHelpers';
import * as styles from './styles/styles.module.scss';

type PhotoTimeStampProps = {
  timestamp: string;
};

const PhotoTimeStamp = ({ timestamp }: PhotoTimeStampProps): JSX.Element => {
  const languageRegionCode: LanguageRegionCode = useLanguageRegionCode();
  const uploadDate: Date = new Date(timestamp);
  const today: Date = new Date(Date.now());
  let formattedUploadDate: string = Intl.DateTimeFormat(languageRegionCode, { year: 'numeric', month: 'short', day: 'numeric' }).format(uploadDate);
  if ((+today - +uploadDate) / MILLISECONDS_IN_DAY < 7) {
    formattedUploadDate = humanizeTimeSpan(timestamp.toString(), languageRegionCode);
  }

  return (
    <div className={styles.photoTimeDisplay}>
      <span>{formattedUploadDate}</span>
    </div>
  );
};

export { PhotoTimeStamp as default, PhotoTimeStampProps };
